module.exports = __webpack_public_path__ + "img/shenpi.cd2a5d13.png";